import * as React from 'react';
import { useEffect, useState } from 'react';
import {
  Button,
  ColumnLayout,
  Container,
  Flashbar,
  Form,
  FormField,
  Header,
  Input,
  SpaceBetween,
} from '@amzn/awsui-components-react-v3';
import { Page } from 'src/routes';
import { editWorkspace, getWorkspace } from 'src/api/permissions';
import { scrollUp } from 'src/components/utils/navigation';
import { FORM_CONTENT_TYPE } from 'src/commons/constants';
import { CommonPageProps } from 'src/components/common/CommonPageProps';

export interface WorkspaceUpdateProps extends CommonPageProps {
  setContentType: any;
  match: any;
  activeGroup: string;
  username: string;
}

export const WorkspaceUpdate = (props: WorkspaceUpdateProps) => {
  const [workspaceName, setWorkspaceName] = useState(undefined);
  const [notifications, setNotifications] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);

  useEffect(() => {
    props.setContentType(FORM_CONTENT_TYPE);
    handleRefresh();
  }, []);

  const handleRefresh = async () => {
    const getWorkspaceResult = await getWorkspace({
      workspaceId: props.match.params.workspaceId,
    });
    if (getWorkspaceResult.succeeded) {
      setWorkspaceName(getWorkspaceResult.workspace.workspaceName);
    }
  };

  const handleEdit = async () => {
    setButtonLoading(true);
    try {
      const editWorkspaceResult = await editWorkspace({
        workspaceId: props.match.params.workspaceId,
        workspaceName: workspaceName,
      });
      if (editWorkspaceResult.succeeded) {
        setButtonLoading(false);
        setNotifications([
          {
            type: 'success',
            content: `Successfully updated workspace.`,
            dismissible: true,
            onDismiss: () => setNotifications([]),
          },
        ]);
      } else {
        setButtonLoading(false);
        setNotifications([
          {
            type: 'error',
            content: 'Failed to update workspace. Reason:' + editWorkspaceResult.message,
            dismissible: true,
            onDismiss: () => setNotifications([]),
          },
        ]);
      }
    } catch (e) {
      setButtonLoading(false);
      setNotifications([
        {
          type: 'error',
          content: 'Failed to update workspace. Reason:' + e.message,
          dismissible: true,
          onDismiss: () => setNotifications([]),
        },
      ]);
    }
    scrollUp();
  };

  return (
    <div>
      <Flashbar items={notifications}></Flashbar>
      <Form
        header={
          <Header variant={'h1'} description='Use this page to update your workspace details.'>
            Update workspace
          </Header>
        }
        actions={
          <SpaceBetween size={'xs'} direction={'horizontal'}>
            <Button variant='link' onClick={() => props.setRedirect(Page.BROWSE_WORKSPACES)}>
              Cancel
            </Button>
            <Button variant='primary' onClick={handleEdit} loading={buttonLoading}>
              Submit
            </Button>
          </SpaceBetween>
        }
      >
        <Container header={<Header variant={'h2'}>Workspace details</Header>}>
          <ColumnLayout>
            <>
              <FormField label={<div>Workspace name</div>} description='The name of the workspace.'>
                <Input
                  onChange={(event) => setWorkspaceName(event.detail.value)}
                  ariaRequired={true}
                  value={workspaceName}
                />
              </FormField>
            </>
          </ColumnLayout>
        </Container>
      </Form>
    </div>
  );
};
